const PlainErrorFallback = () => (
  <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
    <h1>Something went wrong</h1>
    <p>
      The application failed to start. Please restart the app or contact support
      if the problem continues.
    </p>
    <button type="button" onClick={() => window.location.reload()}>
      Reload
    </button>
  </div>
);

export default PlainErrorFallback;
